<template>
    <div class="returns-filter">
      <div class="filter-title" @click="expandCollapse">
        <i class="icon" :class="expanded ? 'icon-down-carrot' : 'icon-right-carrot'" />
        Settings:
        <span class="filter-title-options"> {{ filterText }}
        </span>
      </div>
      <div
        v-if="expanded"
        ref="settings-filter"
        class="settings-filter-content filter-content clearfix"
      >
        <span class="share-class">
          Share Class
          <slot name="Iball_shareclass" />
          <select v-model="selectedClass" class="share-class-select">
            <option
              v-for="(shareClass, index) in shareClasses"
              :key="index"
              :selected="shareClass === selectedClass"
            >{{ shareClass }}</option>
          </select>
          <i class="icon icon-down-carrot" />
        </span>
        <span>
          <div class="filter-label">Returns:</div>
          <span>
            <div class="monthly-button" @click="timeSpan = 'monthly'">
              <div v-if="timeSpan === 'monthly'" class="fill" />
            </div>
            <div class="radio-label">Monthly</div>
          </span>
          <span>
            <div class="quarterly-button" @click="timeSpan = 'quarterly'">
              <div v-if="timeSpan === 'quarterly'" class="fill" />
            </div>
            <div class="radio-label">Quarterly</div>
          </span>
        </span>
        <span>
          <div class="indicies-button" @click="showIndices = !showIndices">
            <div v-if="showIndices" class="checked" />
          </div>
          <div class="box-label">Show Indices</div>
        </span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    Name: 'SettingFilters',
      props: ['widgetData'],
      data() {
          return {
              expanded: true
          };
      },
      computed: {
          shareClasses() {
              return this.widgetData && this.widgetData.shareClasses || [];
          },
          showIndices: {
              get() { return this.widgetData.showIndices || false; },
              set(val) { this.$emit('toggle-show-indices', val); }
          },
          selectedClass: {
              get() { return this.widgetData.selectedShareClass || '1'; },
              set(val) { this.$emit('update-share-class', val); }
          },
          timeSpan: {
              get() { return this.widgetData.timeSpan || 'monthly'; },
              set(val) { this.$emit('toggle-time-span', val); }
          },
          filterText() {
              let text = '';
              if (this.shareClasses.length) text += `Share Class ${this.selectedClass}`;
              if (text.length) text += ', ';
              text += `Returns ${this.timeSpan}`;
              return text;
          }
      },
      methods: {
          expandCollapse() {
              this.expanded = !this.expanded;
          }
      }
  };
  </script>
  
  <style lang="less" scoped>
  @import '~_css_/variables';
  .returns-filter{
      .filter-title {
          background-color: #f6f8f8;
          font-family: @avenir-regular;
          padding: 4px;
          font-weight: bold;
          min-height: 31px;
          .icon {
              font-size: 9px;
              line-height: 15px;
              color: @brand-primary;
              padding-left: 5px;
          }
          .filter-title-options {
              font-family: @avenir-regular;
              font-size: 14px;
              color: @dark-gray;
              font-weight: normal;
              text-transform: capitalize;
          }
      }
      .filter-content {
          padding: 10px 24px;
          .filter-label {
              font-weight: 700;
              margin-bottom: 5px;
          }
      }
      .settings-filter-content {
          background-color: #e6e6e6;
          .share-class {
              //the default is not to show the shareclass dropdown in the filters.
              //If it is needed, then a style override is needed in the front end that hosts this component
              display: none;
              position: relative;
              margin-right: 10px;
              font-weight: 700;
              i {
                  position: absolute;
                  right: 6px;
                  top: 50%;
                  transform: translateY(-50%);
                  pointer-events: none;
              }
              .share-class-select {
                  &::-ms-expand {
                      display: none; /* hide the default arrow in ie10 and ie11 */
                  }
                  appearance: none;
                  padding-left: 5px;
                  min-width: 60px;
                  font-weight: normal;
                  font-family: 'Avenir', Helvetica, Arial, sans-serif;
              }
          }
          span {
              min-width: max-content;
              display: inline-block;
          }
          div {
              display: inline-block;
              &.monthly-button, &.quarterly-button {
                  background-color: #fff;
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  border: 1px solid @light-gray;
                  position: relative;
                  margin: 0px 5px -4px 5px;
                  .fill {
                      display: inline-block;
                      position: absolute;
                      left: 50%;
                      top: 50%;
                      transform: translateX(-50%) translateY(-50%);
                      border-radius: 50%;
                      border: 5px solid @gray;
                  }
              }
              &.indicies-button {
                  height: 17px;
                  width: 17px;
                  border-radius: 2px;
                  background-color: #fff;
                  border: 1px solid @light-gray;
                  margin: 0px 5px -3px 5px;
                  position: relative;
                  .checked {
                      position: absolute;
                      height: 5px;
                      width: 12px;
                      border-left: 2px solid @gray;
                      border-bottom: 2px solid @gray;
                      top: 48%;
                      left: 51%;
                      transform: translateX(-50%) translateY(-50%) rotateZ(-55deg);
  
                  }
              }
          }
      }
      @media screen and (max-width: 425px) {
          .filter-content {
              padding: 10px 8px;
          }
      }
  }
  </style>
  
  